'use client';

import { useMemo } from 'react';
import PropTypes from 'prop-types';

import { DeviceContext } from './device-context';

export default function DeviceProvider({ children, deviceType }) {
  const value = useMemo(() => ({
    deviceType: deviceType || 'desktop'
  }), [deviceType]);

  return (
    <DeviceContext.Provider value={value}>
      {children}
    </DeviceContext.Provider>
  );
}

DeviceProvider.propTypes = {
  children: PropTypes.node,
  deviceType: PropTypes.string
};
